// SCSS
import './scss/_variables.scss';
import './scss/_prerequisites.scss';
import './scss/fa-all.scss';
import './scss/buttons.scss';
import './scss/forms.scss';
import './scss/components.scss';
import './scss/mobile.scss';
import 'slick-carousel/slick/slick.scss';

// JS
import 'slick-carousel/slick/slick.js';
import './js/custom.js';